import { Injectable } from '@angular/core';
import { Credentials, IAuthStrategy, UsernameAndPassword, UsernameAndPasswordAndProfile } from '../interfaces/auth-strategy.interface';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Wso2AuthStrategyService implements IAuthStrategy {

  constructor() { }

  login(credentials: Credentials<UsernameAndPasswordAndProfile>) {
    console.log(credentials.data.username);
    return of('Wso2');
  }
}
